module.exports = __webpack_public_path__ + "img/upload-file.3287520a.svg";